<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />
    <b-row>
      <b-col sm="12"> <h4 style="text-align: center"> 6. DATOS DE LA PAREJA  </h4>  </b-col>
    </b-row>

    <b-row>
      <b-col >
        <b-form-group label="¿TIENE PAREJA?">
          <b-form-radio-group v-model="pareja.ninguno" :disabled="status === 'Concluida'">
            <b-form-radio :value="false">SI</b-form-radio>
            <b-form-radio :value="true">NO</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>

      <b-col v-show="!pareja.ninguno" sm="12" >
        <h5 style="text-align: center" :class="{invalid_input: $v.pareja.tipoOperacion.$error}">Elegir un tipo de operación </h5>
      </b-col> 
        <b-col >
        <b-button
          v-if="status !== 'Concluida'"              
          size="sm"
          v-show="!pareja.ninguno"
          :variant="pareja.tipoOperacion == 'AGREGAR'? 'primary' : 'outline-primary'"
          @click="pareja.tipoOperacion = 'AGREGAR'"
          
          >AGREGAR</b-button>
      </b-col>     
      <b-col >
        <b-button
          v-if="status !== 'Concluida' "              
          size="sm"
          v-show="!pareja.ninguno"
          :variant="pareja.tipoOperacion == 'SIN CAMBIOS'? 'info' : 'outline-info'"
          @click="pareja.tipoOperacion = 'SIN CAMBIOS'"
          >SIN CAMBIOS</b-button>
      </b-col>
      <b-col >
        <b-button
          v-if="status !== 'Concluida'"
          :variant="pareja.tipoOperacion == 'MODIFICAR'? 'success' : 'outline-success'"
          size="sm"
          v-show="!pareja.ninguno"
          @click="pareja.tipoOperacion = 'MODIFICAR'"
          
          >MODIFICAR</b-button>
      </b-col>

    </b-row>
    <br />

    <b-row v-if="!pareja.ninguno">
      <br />
      <br />

      <b-col md="4">
        <b-form-group>
          <label>NOMBRE(S)</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="pareja.nombre"
            placeholder="NOMBRE (S)"
            :class="{invalid_input: $v.pareja.nombre.$error}"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label >PRIMER APELLIDO</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="pareja.primerApellido"
            placeholder="APELLIDO PATERNO"
            :class="{invalid_input: $v.pareja.primerApellido.$error}"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label>SEGUNDO APELLIDO</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="pareja.segundoApellido"
            placeholder="PELLIDO MATERNO"
            :class="{invalid_input: $v.pareja.segundoApellido.$error}"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group label="FECHA DE NACIMIENTO">
          <datetime
          :disabled="status === 'Concluida'"
            :input-class="'form-control input'"
            v-model="pareja.fechaNacimiento"
            type="date"
            :class="{invalid_input: $v.pareja.fechaNacimiento.$error}"
          />
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label>RFC</label>
          <b-form-input

          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="pareja.rfc"
            placeholder="RFC"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group label="RELACIÓN CON EL DECLARANTE">
          <b-form-select class="mb-3" v-model="pareja.relacionConDeclarante" :options="parentesco" :disabled="status === 'Concluida'"></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="¿ES CIUDADANO EXTRANJERO?">
          <b-form-radio-group :disabled="status === 'Concluida'" v-model="pareja.ciudadanoExtranjero">
            <b-form-radio :value="true">SI</b-form-radio>
            <b-form-radio :value="false">NO</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label >CURP</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="pareja.curp"
            placeholder="CURP"
            :class="{invalid_input: $v.pareja.curp.$error}"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="¿ES DEPENDIENTE ECÓNOMICO?">
          <b-form-radio-group :disabled="status === 'Concluida'" v-model="pareja.esDependienteEconomico" >
            <b-form-radio :value="true">SI</b-form-radio>
            <b-form-radio :value="false">NO</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group label="LUGAR DONDE RESIDE ">
          <b-form-select
          :disabled="status === 'Concluida'"
            class="mb-3"
            v-model="pareja.lugarDondeReside"
            @change="llenaEspaciosDomicilio()"
            :options="residencia"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="¿HABITA EN EL DOMICILIO DEL DECLARANTE?">
          <b-form-radio-group :disabled="status === 'Concluida'"  v-model="pareja.habitaDomicilioDeclarante" @change="llenaEspaciosDomicilio2()">
            <b-form-radio :value="true">SI</b-form-radio>
            <b-form-radio :value="false">NO</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if=" muestraDomicilio && !pareja.ninguno && mostrarTipoNacionalidad === 'MEXICO'  " >
      <b-col md="6">
        <b-form-group>
          <label>CALLE</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="pareja.domicilioMexico.calle"
            placeholder="CALLE"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label>NO EXT</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="pareja.domicilioMexico.numeroExterior"
            placeholder="NUM EXTERIOR"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label>NO INT</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
             v-model="pareja.domicilioMexico.numeroInterior"
            placeholder="NUM INTERIOR"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label>ENTIDAD FEDERATIVA</label>
          <b-form-select
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="estadoClave"
            :options="listaE"
            text-field="valor"
            value-field="clave"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label>MUNICIPIO</label>
          <b-form-select
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            :options="cargaMunicipio"
            v-model="muniClave"
            text-field="valor"
            value-field="clave"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label>COLONIA</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="pareja.domicilioMexico.coloniaLocalidad"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label>CÓDIGO POSTAL</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="pareja.domicilioMexico.codigoPostal"
            placeholder="CÓDIGO POSTAL"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

   <b-row v-if=" muestraDomicilio && !pareja.ninguno &&  mostrarTipoNacionalidad === 'EXTRANJERO'">
      <b-col md="2">
        <b-form-group>
          <label>País:</label>
          <b-form-select
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="pareja.domicilioExtranjero.pais"
            :options="pais"
            text-field="nombre"
            value-field="clave"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label>Calle:</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            type="text"
            v-model="pareja.domicilioExtranjero.calle"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="2">
        <b-form-group>
          <label>Número exterior:</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            type="text"
            v-model="pareja.domicilioExtranjero.numeroExterior"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="2">
        <b-form-group>
          <label>Número interior:</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            type="text"
            v-model="pareja.domicilioExtranjero.numeroInterior"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label>Ciudad:</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            type="text"
            v-model="pareja.domicilioExtranjero.ciudadLocalidad"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <label>Estado Provincia:</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            type="text"
            v-model="pareja.domicilioExtranjero.estadoProvincia"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label>Código postal:</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            type="text"
            v-model="pareja.domicilioExtranjero.codigoPostal"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="!pareja.ninguno">
      <br />
      <b-col md="12">
        <div class="customHr">.</div>
      </b-col>
      <b-col sm="12" >
        <h5 style="text-align: center" >ACTIVIDAD LABORAL DE LA PAREJA </h5>
      </b-col> 
      
      <b-col >
        <b-button
          v-if="status !== 'Concluida'"              
          size="sm"
          @change="llenaEspacionsTrabajo()"
          :variant="pareja.actividadLaboral.clave == 'PUB' ? 'primary' : 'outline-primary'"
          @click="pareja.actividadLaboral.clave = 'PUB', pareja.actividadLaboral.valor = 'PUBLICO' "
          >PÚBLICO</b-button>
      </b-col>     
      <b-col >
        <b-button
          v-if="status !== 'Concluida' "              
          size="sm"
          @change="llenaEspacionsTrabajo()"
          :variant="pareja.actividadLaboral.clave == 'PRI' ? 'info' : 'outline-info'"
          @click="pareja.actividadLaboral.clave = 'PRI', pareja.actividadLaboral.valor = 'PRIVADO' "
          >PRIVADO</b-button>
      </b-col>
      <b-col >
        <b-button
          v-if="status !== 'Concluida'"
          :variant="pareja.actividadLaboral.clave == 'OTRO'? 'success' : 'outline-success'"
          size="sm"
          @click="pareja.actividadLaboral.clave = 'OTRO', pareja.actividadLaboral.valor = 'OTRO' "
          >OTRO</b-button>
      </b-col>
      <b-col >
        <b-button
          v-if="status !== 'Concluida'"
          @change="llenaEspacionsTrabajo()"
          :variant="pareja.actividadLaboral.clave == 'NIN'? 'danger' : 'outline-danger'"
          size="sm"
          @click="pareja.actividadLaboral.clave = 'NIN', pareja.actividadLaboral.valor = 'NINGUNO' "
          >NINGUNO</b-button>
      </b-col>
  </b-row>

    <b-row v-if="!pareja.ninguno && pareja.actividadLaboral.clave === 'PUB'">
     <br/>
      <br/>

      <b-col md="3">
        <b-form-group label="NIVEL / ORDEN DE GOBIERNO ">
          <b-form-select
            :disabled="status === 'Concluida'"
            @change="cambios = true"
            :options="nivelOrdenGobierno"
            v-model="pareja.actividadLaboralSectorPublico.nivelOrdenGobierno"
            class="mb-3"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="ÁMBITO PÚBLICO ">
          <b-form-select
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            :options="ambitoPublico"
            v-model="pareja.actividadLaboralSectorPublico.ambitoPublico"
            class="mb-3"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label >NOMBRE DEL ENTE PÚBLICO</label>
          <b-form-input
            :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="pareja.actividadLaboralSectorPublico.nombreEntePublico"
            placeholder="NOMBRE DEL ENTE PÚBLICO"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label >ÁREA DE ADSCRIPCIÓN</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="pareja.actividadLaboralSectorPublico.areaAdscripcion"
            placeholder="ÁREA DE ADSCRIPCIÓN"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label>EMPLEO, CARGO O COMISIÓN</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="pareja.actividadLaboralSectorPublico.empleoCargoComision"
            placeholder="EMPLEO, CARGO O COMISIÓN"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label >FUNCIÓN PRINCIPAL</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="pareja.actividadLaboralSectorPublico.funcionPrincipal"
            placeholder="FUNCIÓN PRINCIPAL"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="FECHA DE INGRESO">
          <datetime
            :disabled="status === 'Concluida'"
            :input-class="'form-control input'"
            v-model="pareja.actividadLaboralSectorPublico.fechaIngreso"
            type="date"
          />
        </b-form-group>
      </b-col>

      <b-col md="2">
        <b-form-group>
          <label >SALARIO MENSUAL NETO</label>
          <b-form-input
            :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="pareja.actividadLaboralSectorPublico.salarioMensualNeto.valor"
            type="number"
            placeholder="SALARIO"
          ></b-form-input>
        </b-form-group>
      </b-col>
 

      <b-col md="1">
                <b-form-group label="Moneda:">
                  <b-form-input
                  
                    v-model="pareja.actividadLaboralSectorPublico.salarioMensualNeto.moneda"
                    type="text"
                    placeholder="MXN"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
    </b-row>
    <b-row v-if="!pareja.ninguno && (pareja.actividadLaboral.clave === 'PRI' || pareja.actividadLaboral.clave === 'OTRO') ">
      <b-col md="4">
        <b-form-group label="Sector Privado: ">
          <b-form-select
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            :options="sectorPrivado"
            text-field="valor"
            value-field="clave"
            v-model="pareja.actividadLaboralSectorPrivadoOtro.sector.clave"
            class="mb-3"
          >
          <template v-slot:first>
              <option :value="null">Selecciona
              </option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>

     

      <b-col md="8">
        <b-form-group>
          <label >Institución/Empresa/Nombre, denominación o razón social:</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="
              pareja.actividadLaboralSectorPrivadoOtro
                .nombreEmpresaSociedadAsociacion
            "
            type="text"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <label >RFC</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="pareja.actividadLaboralSectorPrivadoOtro.rfc"
           
            placeholder="RFC"
          ></b-form-input>
        </b-form-group>
      </b-col>

    

      <b-col md="6">
        <b-form-group>
          <label >Puesto o cargo desempeñado:</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="
              pareja.actividadLaboralSectorPrivadoOtro.empleoCargoComision
            "
            type="text"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

    
      <b-col md="3">
        <b-form-group label="Ingreso:">
          <datetime
          :disabled="status === 'Concluida'"
            id="ingreso"
            :input-class="'form-control input'"
            v-model="pareja.actividadLaboralSectorPrivadoOtro.fechaIngreso"
            type="date" placeholder="Ingrese fecha"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label >Salario Mensual Neto:</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model=" pareja.actividadLaboralSectorPrivadoOtro.salarioMensualNeto.valor "
           placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
            <b-col md="2" >
              <b-form-group>
                <label >Moneda:</label>
                <b-form-input
                  v-model="pareja.actividadLaboralSectorPrivadoOtro.salarioMensualNeto.moneda"
                  type="text"
                  value="MXN"
                  disabled
                   placeholder="MXN"
                ></b-form-input>
              </b-form-group>
            </b-col>


      <b-col md="3">
        <b-form-group label="¿Es proveedor o contratista de gobierno?">
          <b-form-radio-group
            :disabled="status === 'Concluida'"
            v-model="pareja.actividadLaboralSectorPrivadoOtro.proveedorContratistaGobierno"
            :name="'contratista'"
          >
            <b-form-radio :value="true">SI</b-form-radio>
            <b-form-radio :value="false">NO</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>

    <br />
    <br />
    <b-row>
      <b-col md="12">
        <b-form-group>
          <label >ACLARACIONES / OBSERVACIONES</label>
          <b-form-input
           :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="pareja.aclaracionesObservaciones"
            placeholder="ACLARACIONES / OBSERVACIONES"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
<b-row>
      <b-col >
        <b-button variant="success" @click="verSeccion(0)" :disabled="enviando">Regresar al índice</b-button>
      </b-col>

      <b-col>
        <p v-if="cambios" class="error-text"><i>No se han guardado los cambios</i> </p>
      </b-col> 
      <b-col >
        <b-button variant="secondary" @click="verSeccion(5)" :disabled="enviando">Anterior</b-button>
        <b-button
          class="pull-right"
          variant="primary"
          @click="actualizarSeccion()"
          :disabled="enviando"
        >Siguiente</b-button>
      </b-col>
    </b-row>
   
   
  </div>
</template>

<script>
import axios from "axios";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { muni } from "../../../store/municipios";
import { paises } from "../../../store/paises";
import { monedas } from "../../../store/monedas";

export default {
  name:"pareja",
  props: ["pareja", "status"],
  components: {
    Datetime,
    Loader
  },
  watch:{
    'estadoClave':function(val){
      let index = this.estados.findIndex(x=>x.clave==val)
      if(index!==-1)this.estadoNombre=this.estados[index].valor;
    },
    'muniClave':function(val){
      let index = this.cargaMunicipio.findIndex(x=>x.clave==val)
      if(index!==-1)this.muniNombre=this.cargaMunicipio[index].valor;
    },

    'pareja.ninguno':function(val){
      
      if(!val){
        this.pareja.relacionConDeclarante = this.pareja.relacionConDeclarante ? this.pareja.relacionConDeclarante : this.parentesco[0]
        this.pareja.lugarDondeReside = this.pareja.lugarDondeReside ? this.pareja.lugarDondeReside : this.residencia[0]
        this.pareja.ciudadanoExtranjero = this.pareja.ciudadanoExtranjero ? this.pareja.ciudadanoExtranjero : false;
        this.pareja.esDependienteEconomico = this.pareja.esDependienteEconomico ? this.pareja.esDependienteEconomico : false;
        this.pareja.habitaDomicilioDeclarante = this.pareja.habitaDomicilioDeclarante ? this.pareja.habitaDomicilioDeclarante : false;
        this.estadoClave = this.pareja.domicilioMexico.entidadFederativa.clave;
        this.muniClave = this.pareja.domicilioMexico.municipioAlcaldia.clave;
      }
    },
    'pareja.actividadLaboral.clave':function(val){
      if(val=='PUB'){
        this.pareja.actividadLaboralSectorPublico.nivelOrdenGobierno = this.nivelOrdenGobierno[0]
        this.pareja.actividadLaboralSectorPublico.ambitoPublico = this.ambitoPublico[0]
      }
      else if(val == 'PRI'){
        this.pareja.actividadLaboralSectorPrivadoOtro.sector.clave = this.sectorPrivado[0].clave;
        this.pareja.actividadLaboralSectorPrivadoOtro.sector.valor = this.sectorPrivado[0].valor;

      }
    }
  

  },
  //mounted
  computed: {
    ...mapGetters(["httpURL", "sessionToken"]),

    muestraDomicilio() {
      if (
        this.pareja.lugarDondeReside !== null &&
        this.pareja.habitaDomicilioDeclarante !== null
      ) {
        if (
          this.pareja.lugarDondeReside !== "SE_DESCONOCE" &&
          this.pareja.habitaDomicilioDeclarante === false
        ) {
          return true;
        }
        return false;
      }
      return false;
    },
    mostrarTipoNacionalidad() {
      if (this.pareja.lugarDondeReside !== null) {
        if (this.pareja.lugarDondeReside === "MEXICO") {
          return "MEXICO";
        } else if (this.pareja.lugarDondeReside === "EXTRANJERO") {
          return "EXTRANJERO";
        } else if (this.pareja.lugarDondeReside === "SE_DESCONOCE") {
          return "NINGUNO";
        }
      } else {
        return "NINGUNO";
      }
    },
    cargaMunicipio() {
      let listaMuni = [];

      if (this.estadoClave !== null) {
        this.municipios.forEach(value => {
          if (value.claveEstado === this.estadoClave) {
            listaMuni.push(value);
          }
        });
      }
      return listaMuni;
    }
  },
  validations:{
    
    // actividadLaboralSectorPublico: {
    //   ambitoPublico: {required},
    //   areaAdscripcion: {required},
    //   empleoCargoComision: {required},
    //   fechaIngreso: {required},
    //   funcionPrincipal: {required},
    //   nivelOrdenGobierno: {required},
    //   nombreEntePublico: {required},
    //   salarioMensualNeto: {
    //   moneda: {required},
    //   valor: {required}
    //   }
    // },
    pareja:{
      tipoOperacion:{required},
      curp: {required},
      //actividadLaboral:{valor:{required}},
      fechaNacimiento:{required},
      nombre: {required},
      primerApellido: {required},
      segundoApellido: {required},
    // domicilioMexico: {
    //   calle:{required},
    //   codigoPostal: {required},
    //   coloniaLocalidad: {required},
    //   entidadFederativa: {required},
    //   municipioAlcaldia:{required},
    //   numeroExterior: {required},
    //   numeroInterior:{required},
    // },
    
    // lugarDondeReside:{required},
    // relacionConDeclarante: {required},
    //rfc: {required},
    }
  },
  data: function() {
    return {
      titulo: this.$route.name,
      enviando: false,
      cambios: false,
      banderaTrabaja: false,
      parentesco: [
        "CONYUGE",
        "CONCUBINA CONCUBINARIO UNION LIBRE",
        "SOCIEDAD DE CONVIVENCIA"
      ],
      residencia: ["MEXICO", "EXTRANJERO", "SE DESCONOCE"],
      estados: [
        { clave: "01", valor: "AGUASCALIENTES" },
        { clave: "02", valor: "BAJA CALIFORNIA" },
        { clave: "03", valor: "BAJA CALIFORNIA SUR" },
        { clave: "04", valor: "CAMPECHE" },
        { clave: "05", valor: "COAHUILA DE ZARAGOZA" },
        { clave: "06", valor: "COLIMA" },
        { clave: "07", valor: "CHIAPAS" },
        { clave: "08", valor: "CHIHUAHUA" },
        { clave: "09", valor: "DISTRITO FEDERAL" },
        { clave: "10", valor: "DURANGO" },
        { clave: "11", valor: "GUANAJUATO" },
        { clave: "12", valor: "GUERRERO" },
        { clave: "13", valor: "HIDALGO" },
        { clave: "14", valor: "JALISCO" },
        { clave: "15", valor: "MÉXICO" },
        { clave: "16", valor: "MICHOACÁN DE OCAMPO" },
        { clave: "17", valor: "MORELOS" },
        { clave: "18", valor: "NAYARIT" },
        { clave: "19", valor: "NUEVO LEÓN" },
        { clave: "20", valor: "OAXACA" },
        { clave: "21", valor: "PUEBLA" },
        { clave: "22", valor: "QUERÉTARO" },
        { clave: "23", valor: "QUINTANA ROO" },
        { clave: "24", valor: "SAN LUIS POTOSÍ" },
        { clave: "25", valor: "SINALOA" },
        { clave: "26", valor: "SONORA" },
        { clave: "27", valor: "TABASCO" },
        { clave: "28", valor: "TAMAULIPAS" },
        { clave: "29", valor: "TLAXCALA" },
        { clave: "30", valor: "VERACRUZ DE IGNACIO DE LA LLAVE" },
        { clave: "31", valor: "YUCATÁN" },
        { clave: "32", valor: "ZACATECAS" }
      ],
      listaE: [],
      banderaNacionalidad: "México",
      estadoNombre: null,
      estadoClave: null,
      muniNombre: null,
      muniClave: null,
      clavesPais: "",
      municipios: muni,
      pais: paises,
      pais2: [
        { clave: "MX", valor: "MÉXICO" },
        { clave: "EX", valor: "EXTRANJERO" }
      ],
      nivelOrdenGobierno: ["FEDERAL", "ESTATAL", "MUNICIPAL ALCALDIA"],
      ambitoPublico: [
        "EJECUTIVO",
        "LEGISLATIVO",
        "JUDICIAL",
        "ORGANO AUTONOMO"
      ],
      sectorPrivado: [
        { clave: "AGRI", valor: "AGRICULTURA" },
        { clave: "MIN", valor: "MINERÍA" },
        { clave: "EELECT", valor: "ENERGÍA ELÉCTRICA" },
        { clave: "CONS", valor: "CONSTRUCCIÓN" },
        { clave: "INDMANU", valor: "INDUSTRIA MANUFACTURERA" },
        { clave: "CMAYOR", valor: "COMERCIO AL POR MAYOR" },
        { clave: "CMENOR", valor: "COMERCIO AL POR MENOR" },
        { clave: "TRANS", valor: "TRANSPORTE" },
        { clave: "MEDIOM", valor: "MEDIOS MASIVOS" },
        { clave: "SERVFIN", valor: "SERVICIOS FINANCIEROS" },
        { clave: "SERVINM", valor: "SERVICIOS INMOBILIARIOS" },
        { clave: "SERVPROF", valor: "SERVICIOS PROFESIONALES" },
        { clave: "SERVCORP", valor: "SERVICIOS CORPORATIVOS" },
        { clave: "SERVS", valor: "SERVICIOS DE SALUD" },
        { clave: "SERVESPAR", valor: "SERVICIOS DE ESPARCIMIENTO" },
        { clave: "SERVALOJ", valor: "SERVICIOS DE ALOJAMIENTO" },
        { clave: "OTRO", valor: "AGRICULTURA" }
      ],
      tipoMoneda: monedas
    };
  },
  methods: {
    actualizarSeccion() {
      let pasar = false
      //tiene pareja
      if(!this.pareja.ninguno){
        this.$v.$touch();  
        if (!this.$v.$invalid) pasar = true
      }
      //no tiene pareja
      else {
       // console.log("bien");
        pasar = true
      }
        
      if(!this.pareja.ninguno){
        if(this.pareja.actividadLaboralSectorPrivadoOtro.sector.clave){
        let index = this.sectorPrivado.findIndex( x => x.clave == this.pareja.actividadLaboralSectorPrivadoOtro.sector.clave);
        if(index) this.pareja.actividadLaboralSectorPrivadoOtro.sector.valor = this.sectorPrivado[index].valor;
      

        if (this.pareja.actividadLaboral.clave !== null) {
          if (this.pareja.actividadLaboral.clave === "PUB")
            this.pareja.actividadLaboral.valor = "Público";
          else if (this.pareja.actividadLaboral.clave === "PRI")
            this.pareja.actividadLaboral.valor = "Privado";
          else if (this.pareja.actividadLaboral.clave === "Otro")
            this.pareja.actividadLaboral.valor = "OTRO";
          else if (this.pareja.actividadLaboral.clave === "NIN")
            this.pareja.actividadLaboral.valor = "NINGUNO";
        }
        }
      }
    if(pasar){
      this.enviando = true;
      axios.put( this.httpURL +"/declaraciones/V2/datosPareja/" +  this.$route.params.id,
          {
            tipoOperacion: this.pareja.tipoOperacion,
            ninguno: this.pareja.ninguno,
            tipoOperacion: this.pareja.tipoOperacion,
            nombre: this.pareja.nombre,
            primerApellido: this.pareja.primerApellido,
            segundoApellido: this.pareja.segundoApellido,
            fechaNacimiento: this.pareja.fechaNacimiento,
            rfc: this.pareja.rfc,
            relacionConDeclarante: this.pareja.relacionConDeclarante,
            ciudadanoExtranjero: this.pareja.ciudadanoExtranjero,
            curp: this.pareja.curp,
            esDependienteEconomico: this.pareja.esDependienteEconomico,
            habitaDomicilioDeclarante: this.pareja.habitaDomicilioDeclarante,
            lugarDondeReside: this.pareja.lugarDondeReside,
            MXcalle: this.pareja.domicilioMexico.calle,
            MXnumeroExterior: this.pareja.domicilioMexico.numeroExterior,
            MXnumeroInterior: this.pareja.domicilioMexico.numeroInterior,
            MXcoloniaLocalidad: this.pareja.domicilioMexico.coloniaLocalidad,
            MXmunicipioAlcaldiaClave: this.muniClave,
            MXmunicipioAlcaldiaValor: this.muniNombre,
            MXentidadFederativaClave: this.estadoClave,
            MXentidadFederativaValor: this.estadoNombre,
            MXcodigoPostal: this.pareja.domicilioMexico.codigoPostal,
            EXTcalle: this.pareja.domicilioExtranjero.calle,
            EXTnumeroExterior: this.pareja.domicilioExtranjero.numeroExterior,
            EXTnumeroInterior: this.pareja.domicilioExtranjero.numeroInterior,
            EXTciudadLocalidad: this.pareja.domicilioExtranjero.ciudadLocalidad,
            EXTestadoProvincia: this.pareja.domicilioExtranjero.estadoProvincia,
            EXTpais: this.pareja.domicilioExtranjero.pais,
            EXTcodigoPostal: this.pareja.domicilioExtranjero.codigoPostal,
            actividadLaboralClave: this.pareja.actividadLaboral.clave,
            actividadLaboralValor: this.pareja.actividadLaboral.valor,
            ASPnivelOrdenGobierno: this.pareja.actividadLaboralSectorPublico.nivelOrdenGobierno,
            ASPambitoPublico: this.pareja.actividadLaboralSectorPublico.ambitoPublico,
            ASPnombreEntePublico: this.pareja.actividadLaboralSectorPublico.nombreEntePublico,
            ASPareaAdscripcion: this.pareja.actividadLaboralSectorPublico.areaAdscripcion,
            ASPempleoCargoComision: this.pareja.actividadLaboralSectorPublico.empleoCargoComision,
            ASPfuncionPrincipal: this.pareja.actividadLaboralSectorPublico.funcionPrincipal,
            ASPsalarioMensualNetoValor: this.pareja.actividadLaboralSectorPublico.salarioMensualNeto.valor,
            ASPsalarioMensualNetoMoneda: "MXN",
            ASPfechaIngreso: this.pareja.actividadLaboralSectorPublico.fechaIngreso,
            ASPRnombreEmpresaSociedadAsociacion: this.pareja.actividadLaboralSectorPrivadoOtro.nombreEmpresaSociedadAsociacion,
            ASPRempleoCargoComision: this.pareja.actividadLaboralSectorPrivadoOtro.empleoCargoComision,
            ASPRrfc: this.pareja.actividadLaboralSectorPrivadoOtro.rfc,
            ASPRfechaIngreso: this.pareja.actividadLaboralSectorPrivadoOtro.fechaIngreso,
            ASPRsectorClave: this.pareja.actividadLaboralSectorPrivadoOtro.sector.clave,
            ASPRsectorValor: this.pareja.actividadLaboralSectorPrivadoOtro.sector.valor,
            ASPRsalarioMensualNetoValor: this.pareja.actividadLaboralSectorPrivadoOtro.salarioMensualNeto.valor,
            ASPRsalarioMensualNetoMoneda: this.pareja.actividadLaboralSectorPrivadoOtro.salarioMensualNeto.moneda,
            ASPRproveedorContratistaGobierno: this.pareja.actividadLaboralSectorPrivadoOtro.proveedorContratistaGobierno,
            aclaracionesObservaciones: this.pareja.aclaracionesObservaciones
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
         // console.log(res);
          //this.pareja = res.data.datosPareja
          //TODO-ATH: Hacer un emit para actualizar los datos de la pareja
          this.verSeccion(7)
          this.$notify({    group: "foo",  type: "success", duration: 2500, speed: 1000, text: res.data.mensaje  });
          this.enviando = false;
          this.cambios = false;
        })
        .catch(error => {
          this.$notify({group: "foo",type: "error", duration: 2500,speed: 1000,text: "No se pudo guardar la sección."});
          this.enviando = false;
        });
    
      }
    
    },

    llenaEspacionsTrabajo() {
      if (this.pareja.actividadLaboral.clave === "PUB") {
        this.pareja.actividadLaboralSectorPrivadoOtro.nombreEmpresaSociedadAsociacion =
          "";
        this.pareja.actividadLaboralSectorPrivadoOtro.empleoCargoComision = "";
        this.pareja.actividadLaboralSectorPrivadoOtro.rfc = "";
        this.pareja.actividadLaboralSectorPrivadoOtro.fechaIngreso = "";
        this.pareja.actividadLaboralSectorPrivadoOtro.sector.clave = "";
        this.pareja.actividadLaboralSectorPrivadoOtro.sector.valor = "";
        this.pareja.actividadLaboralSectorPrivadoOtro.salarioMensualNeto.valor =
          "";
        this.pareja.actividadLaboralSectorPrivadoOtro.salarioMensualNeto.moneda =
          "";
        this.pareja.actividadLaboralSectorPrivadoOtro.proveedorContratistaGobierno =
          "";
      } else if (
        this.pareja.actividadLaboral.clave === "PRI" ||
        this.pareja.actividadLaboral.clave === "Otro"
      ) {
        this.pareja.actividadLaboralSectorPublico.nivelOrdenGobierno = "";
        this.pareja.actividadLaboralSectorPublico.ambitoPublico = "";
        this.pareja.actividadLaboralSectorPublico.nombreEntePublico = "";
        this.pareja.actividadLaboralSectorPublico.areaAdscripcion = "";
        this.pareja.actividadLaboralSectorPublico.empleoCargoComision = "";
        this.pareja.actividadLaboralSectorPublico.funcionPrincipal = "";
        this.pareja.actividadLaboralSectorPublico.salarioMensualNeto.valor = "";
        this.pareja.actividadLaboralSectorPublico.salarioMensualNeto.moneda =
          "";
        this.pareja.actividadLaboralSectorPublico.fechaIngreso = "";
      } else if (this.pareja.actividadLaboral.clave === "NIN") {
        this.pareja.actividadLaboralSectorPublico.nivelOrdenGobierno = "";
        this.pareja.actividadLaboralSectorPublico.ambitoPublico = "";
        this.pareja.actividadLaboralSectorPublico.nombreEntePublico = "";
        this.pareja.actividadLaboralSectorPublico.areaAdscripcion = "";
        this.pareja.actividadLaboralSectorPublico.empleoCargoComision = "";
        this.pareja.actividadLaboralSectorPublico.funcionPrincipal = "";
        this.pareja.actividadLaboralSectorPublico.salarioMensualNeto.valor = "";
        this.pareja.actividadLaboralSectorPublico.salarioMensualNeto.moneda =
          "";
        this.pareja.actividadLaboralSectorPublico.fechaIngreso = "";
        this.pareja.actividadLaboralSectorPrivadoOtro.nombreEmpresaSociedadAsociacion =
          "";
        this.pareja.actividadLaboralSectorPrivadoOtro.empleoCargoComision = "";
        this.pareja.actividadLaboralSectorPrivadoOtro.rfc = "";
        this.pareja.actividadLaboralSectorPrivadoOtro.fechaIngreso = "";
        this.pareja.actividadLaboralSectorPrivadoOtro.sector.clave = "";
        this.pareja.actividadLaboralSectorPrivadoOtro.sector.valor = "";
        this.pareja.actividadLaboralSectorPrivadoOtro.salarioMensualNeto.valor =
          "";
        this.pareja.actividadLaboralSectorPrivadoOtro.salarioMensualNeto.moneda =
          "";
        this.pareja.actividadLaboralSectorPrivadoOtro.proveedorContratistaGobierno =
          "";
      }
    
    },

    llenaEspaciosDomicilio() {
      if (this.pareja.lugarDondeReside !== null) {
        if (this.pareja.lugarDondeReside !== "SE_DESCONOCE") {
          if (this.pareja.lugarDondeReside === "EXTRANJERO") {
            this.pareja.domicilioMexico.calle = "";
            this.pareja.domicilioMexico.numeroExterior = "";
            this.pareja.domicilioMexico.numeroInterior = "";
            this.pareja.domicilioMexico.coloniaLocalidad = "";

            this.muniNombre = "";

            this.estadoNombre = "";
            this.pareja.domicilioMexico.codigoPostal = "";
          } else {
            this.pareja.domicilioExtranjero.calle = "";
            this.pareja.domicilioExtranjero.numeroExterior = "";
            this.pareja.domicilioExtranjero.numeroInterior = "";
            this.pareja.domicilioExtranjero.ciudadLocalidad = "";
            this.pareja.domicilioExtranjero.estadoProvincia = "";
            this.pareja.domicilioExtranjero.pais = "";
            this.pareja.domicilioExtranjero.codigoPostal = "";
          }
        } else {
          this.pareja.domicilioMexico.calle = "";
          this.pareja.domicilioMexico.numeroExterior = "";
          this.pareja.domicilioMexico.numeroInterior = "";
          this.pareja.domicilioMexico.coloniaLocalidad = "";

          this.muniNombre = "";

          this.estadoNombre = "";
          this.pareja.domicilioMexico.codigoPostal = "";
          this.pareja.domicilioExtranjero.calle = "";
          this.pareja.domicilioExtranjero.numeroExterior = "";
          this.pareja.domicilioExtranjero.numeroInterior = "";
          this.pareja.domicilioExtranjero.ciudadLocalidad = "";
          this.pareja.domicilioExtranjero.estadoProvincia = "";
          this.pareja.domicilioExtranjero.pais = "";
          this.pareja.domicilioExtranjero.codigoPostal = "";
        }
      }
    },

    llenaEspaciosDomicilio2() {
      if (this.pareja.habitaDomicilioDeclarante !== null) {
        if (this.pareja.habitaDomicilioDeclarante === true) {
          this.pareja.domicilioMexico.calle = "";
          this.pareja.domicilioMexico.numeroExterior = "";
          this.pareja.domicilioMexico.numeroInterior = "";
          this.pareja.domicilioMexico.coloniaLocalidad = "";

          this.muniNombre = "";

          this.estadoNombre = "";
          this.pareja.domicilioMexico.codigoPostal = "";
          this.pareja.domicilioExtranjero.calle = "";
          this.pareja.domicilioExtranjero.numeroExterior = "";
          this.pareja.domicilioExtranjero.numeroInterior = "";
          this.pareja.domicilioExtranjero.ciudadLocalidad = "";
          this.pareja.domicilioExtranjero.estadoProvincia = "";
          this.pareja.domicilioExtranjero.pais = "";
          this.pareja.domicilioExtranjero.codigoPostal = "";
        }
      }
    },

    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    }
  },


  created() {
//   console.log(this.pareja);
    this.pareja.ninguno = this.pareja.ninguno ? this.pareja.ninguno : false;
    this.listaE = this.estados.sort();
  }
};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
